import { format, isAfter, isBefore, parseISO } from "date-fns";
import React from "react";
import { useParams } from "react-router-dom";
import Event from "./Event";
import getStartAndEndDate from "./utils/getStartAndEndDate";
import useSheets from "./utils/useSheets";

export default function MenuView(props) {
  const params = new URLSearchParams(window.location.search);
  // const isTest = params.get("test");
  const isTest = true;
  const match = useParams<{ community: string; next: string }>();
  let today = new Date();

  if (params.get("date")) {
    const suppliedDate = parseISO(params.get("date"));
    suppliedDate.setHours(today.getHours(), today.getMinutes());
    today = suppliedDate;
  } else if (props.date) {
    today = props.date;
  }

  let todayDay = format(today, "EEEE");

  if (isTest) {
    todayDay = todayDay.toUpperCase();
  }

  // console.log("todayDay", todayDay);
  // const todayWeekNumber = getWeek(today);

  const sheetParams = {
    spreadsheet: "1uqI4zcBy5PGLwr4idoGQx25nAKKSFqYJSNCgXmncg4Q",
    range: "This Week",
  };

  if (match.next) {
    sheetParams.range = "Next Week";
  }

  if (match.community === "fuquay") {
    sheetParams.spreadsheet = "1MI5_3X1rokGZQTT_ut5R6YPUBAYx-eL5-tnMOyYyW0Y";
  }

  if (match.community === "wakefield") {
    sheetParams.spreadsheet = "1FiYWz5XYoglGFe-BQavtpfx-wn-0V-5j1Un2YK3Z8Bs";
  }

  if (match.community === "apex") {
    sheetParams.spreadsheet = "1HvR9SdYm25XpZOskrx0UZ0LGdHcG9VClo1EDYuAYr5A";
  }

  const { events } = useSheets(sheetParams);

  // console.log("events", events);

  const {
    startDate,
    endDate,
    events: culinaryEvents,
  } = useSheets({
    view: "week",
  });

  // const startDate = startOfWeek(today);
  const breakfast = events.filter(
    (e) => e["Event-Name"] === "Breakfast" && e["Day of Week"] === todayDay
  );
  const lunch = events.filter(
    (e) => e["Event-Name"] === "Lunch" && e["Day of Week"] === todayDay
  );
  const dinner = events.filter(
    (e) => e["Event-Name"] === "Dinner" && e["Day of Week"] === todayDay
  );

  // console.log("events", events);
  // console.log("breakfast", breakfast);
  // console.log("lunch", lunch);
  // console.log("dinner", dinner);

  return (
    <React.Fragment>
      <header className="header header--menu"></header>
      <header className="header header--no-bg">
        <h1 className="header__title header__title--menu">
          <strong>{format(today, "EEEE, MMMM d")}</strong>
        </h1>
      </header>
      <div className="calendar-container">
        <main className="menu">
          <div className="menu__item menu__item--alt">
            <div className="menu__title">
              <span className="menu__title-type">Breakfast</span>
              <span className="menu__title-time">Served at 8 a.m.</span>
            </div>
            <div className="menu__content">
              {breakfast.map((m, i) => {
                return <p key={i}>{m["Menu Items"]}</p>;
              })}
            </div>
            <div className="menu__meta">
              (Continental breakfast also available at 7 a.m.)
            </div>
          </div>
          <div className="menu__item">
            <div className="menu__title">
              <span className="menu__title-type">Lunch</span>
              <span className="menu__title-time">Served at 12 p.m.</span>
            </div>
            <div className="menu__content">
              {lunch.map((m, i) => {
                return <p key={i}>{m["Menu Items"]}</p>;
              })}
            </div>
          </div>
          <div className="menu__item menu__item--alt">
            <div className="menu__title">
              <span className="menu__title-type">Dinner</span>
              <span className="menu__title-time">Served at 5 p.m.</span>
            </div>
            <div className="menu__content">
              {dinner.map((m, i) => {
                return <p key={i}>{m["Menu Items"]}</p>;
              })}
            </div>
          </div>
        </main>
        <div className="featured">
          <div className="featured__title">
            Culinary Events
            <br />
            This Week
          </div>
          <div className="featured__content">
            {culinaryEvents
              .filter((e) => {
                const { startDate: eventStartDate } = getStartAndEndDate(e);
                return (
                  e["Culinary-Highlight?"] &&
                  isBefore(eventStartDate, endDate) &&
                  isAfter(eventStartDate, startDate)
                );
              })
              .sort((a, b) => {
                const { startDate: startDateA } = getStartAndEndDate(a);
                const { startDate: startDateB } = getStartAndEndDate(b);

                return startDateA.getTime() - startDateB.getTime();
              })
              .map((e, i) => {
                return (
                  <Event
                    key={i}
                    event={e}
                    type="highlight"
                    community={match.community}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
